import queryString from 'qs';
import { isEmpty, isObject, get, mapValues, omit } from 'lodash';
import { replace } from 'react-router-redux';

import tvtApi from '../services/tvt-api';

import { serializeFilters } from '../utils/filters';

export const SEGMENT_OPEN = 'SEGMENT_OPEN';
export const SEGMENT_CLOSE = 'SEGMENT_CLOSE';
export const SEGMENT_SAVE_REQUEST = 'SEGMENT_SAVE_REQUEST';
export const SEGMENT_SAVE_SUCCESS = 'SEGMENT_SAVE_SUCCESS';
export const SEGMENT_SAVE_ERROR = 'SEGMENT_SAVE_ERROR';
export const SEGMENT_DELETE_REQUEST = 'SEGMENT_DELETE_REQUEST';
export const SEGMENT_DELETE_SUCCESS = 'SEGMENT_DELETE_SUCCESS';
export const SEGMENT_DELETE_ERROR = 'SEGMENT_DELETE_ERROR';

export const SEGMENT_GET_REQUEST = 'SEGMENT_GET_REQUEST';
export const SEGMENT_GET_SUCCESS = 'SEGMENT_GET_SUCCESS';
export const SEGMENT_GET_ERROR = 'SEGMENT_GET_ERROR';
export const UPDATE_FILTER_OPTIONS_SEGMENT = 'UPDATE_FILTER_OPTIONS_SEGMENT';
export const FILTERS_UPDATED = 'FILTERS_UPDATED';

export const BENCHMARK_SELECTED = 'BENCHMARK_SELECTED';

export const updateFilterOptions = (filter, options) => ({
  type: UPDATE_FILTER_OPTIONS_SEGMENT,
  filter,
  options
});

const syncFiltersWithUrl = filters => (dispatch, getState) => {
  const prevLocation = get(getState(), 'router.location', {});
  const fs = mapValues(filters, (f, id) => ({ id, value: f })); // dreadful, but needed
  const filtersQuery = serializeFilters(fs);
  const nextLocation = {
    ...prevLocation,
    search: queryString.stringify({ filters: filtersQuery })
  };

  dispatch(replace(nextLocation));
};

export const updateFilters = (
  filters,
  options = { syncWithUrl: true }
) => dispatch => {
  if (options.syncWithUrl) {
    dispatch(syncFiltersWithUrl(filters));
  }

  dispatch({
    type: FILTERS_UPDATED,
    filters
  });
};

const syncBenchmarkWithUrl = benchmarkUUID => (dispatch, getState) => {
  const prevLocation = get(getState(), 'router.location', {});
  const prevSearch = queryString.parse(
    get(prevLocation, 'search', '').slice(1)
  );

  if (!benchmarkUUID) {
    dispatch(
      replace({
        ...prevLocation,
        search: queryString.stringify(omit(prevSearch, 'benchmark'))
      })
    );
  } else {
    dispatch(
      replace({
        ...prevLocation,
        search: queryString.stringify({
          ...prevSearch,
          benchmark: benchmarkUUID
        })
      })
    );
  }
};

export const openAudienceSegmentWindow = (id, name, filters) => ({
  type: SEGMENT_OPEN,
  id,
  name,
  filters
});

export const closeAudienceSegmentWindow = () => ({
  type: SEGMENT_CLOSE
});

export const requestSaveAudienceSegment = (uuid, name, filters) => ({
  type: SEGMENT_SAVE_REQUEST,
  uuid,
  name,
  filters
});

export const successSaveAudienceSegment = segment => ({
  type: SEGMENT_SAVE_SUCCESS,
  segment
});

export const errorSaveAudienceSegment = (uuid, name, filters, error) => ({
  type: SEGMENT_SAVE_ERROR,
  uuid,
  name,
  filters,
  error
});

export const requestDeleteAudienceSegment = uuid => ({
  type: SEGMENT_DELETE_REQUEST,
  uuid
});

export const successDeleteAudienceSegment = uuid => ({
  type: SEGMENT_DELETE_SUCCESS,
  uuid
});

export const errorDeleteAudienceSegment = (uuid, error) => ({
  type: SEGMENT_DELETE_ERROR,
  uuid,
  error
});

export const requestGetSegments = filters => ({
  type: SEGMENT_GET_REQUEST,
  filters
});

export const loadSegments = segments => ({
  type: SEGMENT_GET_SUCCESS,
  segments
});

export const errorGetSegments = error => ({
  type: SEGMENT_GET_ERROR,
  error
});

export const benchmarkSelected = uuid => ({
  type: BENCHMARK_SELECTED,
  uuid
});

export const getSegments = filters => async dispatch => {
  dispatch(requestGetSegments(filters));
  try {
    const response = await tvtApi.getAllUserSegments();
    const mappedSegments = response.map(segment => ({
      ...segment,
      value: segment.filters || '',
      label: segment.name || ''
    }));

    dispatch(loadSegments(mappedSegments));
  } catch (err) {
    console.log(err);
    dispatch(errorGetSegments(err));
  }
};

export const saveAudienceSegment = (
  uuid,
  name,
  filters,
  options = { isBenchmark: false }
) => async dispatch => {
  dispatch(requestSaveAudienceSegment(uuid, name, filters, options));
  try {
    const uuidValue = isEmpty(uuid) ? '' : uuid;
    const response = await tvtApi.saveAudienceSegment(
      uuidValue,
      name,
      filters,
      options
    );

    if (!isObject(response)) {
      throw Error(response);
    }

    dispatch(successSaveAudienceSegment(response));
    return response;
  } catch (err) {
    dispatch(errorSaveAudienceSegment(uuid, name, filters));
    return false;
  }
};

export const deleteAudienceSegment = uuid => async dispatch => {
  dispatch(requestDeleteAudienceSegment(uuid));
  try {
    const response = await tvtApi.deleteAudienceSegment(uuid);

    if (!isObject(response)) {
      throw Error(response);
    }
    dispatch(successDeleteAudienceSegment(uuid));
    dispatch(getSegments());
  } catch (err) {
    dispatch(errorDeleteAudienceSegment(uuid));
    return false;
  }

  return true;
};

export const selectBenchmark = uuid => async dispatch => {
  try {
    dispatch(benchmarkSelected(uuid));
    dispatch(syncBenchmarkWithUrl(uuid));
  } catch (err) {
    console.log(err);
    return false;
  }

  // dispatch select benchmark

  return true;
};
